export default __webpack_public_path__ + "static/media/background.055c1774.jpg";